export const SAVE_EVENT_STARTED = "SAVE_EVENT_STARTED";
export const SAVE_EVENT_COMPLETED = "SAVE_EVENT_COMPLETED";
export const SAVE_EVENT_FAILED = "SAVE_EVENT_FAILED";
export const GET_EVENT_STARTED = "GET_EVENT_STARTED";
export const GET_EVENT_COMPLETED = "GET_EVENT_COMPLETED";
export const GET_EVENT_FAILED = "GET_EVENT_FAILED";
export const UPDATE_EVENT_STARTED = "UPDATE_EVENT_STARTED";
export const UPDATE_EVENT_COMPLETED = "UPDATE_EVENT_COMPLETED";
export const UPDATE_EVENT_FAILED = "UPDATE_EVENT_FAILED";
export interface IAddUpcomingEvents {
    status: {
        statusCode: number,
        statusDisplay: string,
        statusValue: boolean
    };
    items: Array<any>;
    userInput: {
      insert_datetime:Date,
      inserted_by:string,
      update_datetime:Date,
      updated_by:string
     
    };
    companyautoid: string,
    userID: number;
    isLoading: boolean;
    error: string; 
}
export const saveEvent=(input:any)=>{
 
    return {
      type: SAVE_EVENT_STARTED,
      payload: 'status',
      input: input
    };
  }
  
  export const getallupcomingevents=(input:any)=>{
    
       return {
         type: GET_EVENT_STARTED,
         payload: 'status',
         input: input
       };
     }
     export const updateevents=(input:any)=>{
    //  alert("action updateevents");
      return {
        type: UPDATE_EVENT_STARTED,
        payload: 'status',
        input: input
      };
    }